<template>
  <div class="main">
    <HeaderTitle title="Post Order Status">
      <IconTransfer color="#14444f" size="w-11 h-11" />
    </HeaderTitle>
    <MainContent>
      <div class="pt-5 pb-5" v-if="!isLoading">
        <div
          class="overflow-x-auto relative shadow-md rounded-lg"
          v-if="postOrderStatus.rows?.length != 0"
        >
          <table class="w-full text-sm text-left text-gray-500">
            <thead>
              <tr class="bg-white border-b text-center">
                <th scope="row" class="py-3 px-2">#</th>
                <th scope="row" class="py-3 px-2">Scene Date</th>
                <th scope="row" class="py-3 px-2">Total Post</th>
                <th scope="row" class="py-3 px-2">Error Post</th>
                <th scope="row" class="py-3 px-2">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-white border-b"
                v-for="(item, index) in postOrderStatus.rows"
                :key="item.post_id"
              >
                <td class="py-3 px-2 text-center">
                  {{ (page - 1) * limit + (index + 1) }}
                </td>
                <td class="py-3 px-2">{{ item.scene_date }}</td>
                <td class="py-3 px-2 text-center">{{ item.total_post }}</td>
                <td class="py-3 px-2 text-center">{{ item.error_post }}</td>
                <td
                  class="py-3 px-2 text-center flex justify-center items-center"
                >
                  <LoadingSpin v-if="item.status == 'running'" />
                  <IconCheck color="#03543F" v-if="item.status == 'success'" />
                </td>
              </tr>
            </tbody>
          </table>

          <PaginationComponent
            v-model:length="length"
            v-model:size="limit"
            v-model:page="page"
            @onSelectChange="changePage"
          />
        </div>
      </div>

      <LoadingLottie v-if="isLoading" />

      <div
        class="flex justify-center"
        v-if="!isLoading && postOrderStatus.rows?.length == 0"
      >
        <NoData size="w-full md:w-5/12" />
      </div>
    </MainContent>
  </div>
</template>
<script>
import HeaderTitle from "@/components/HeaderTitle.vue";
import IconCheck from "@/components/icons/IconCheck.vue";
import IconTransfer from "@/components/icons/IconTransfer.vue";
import LoadingSpin from "@/components/LoadingSpin.vue";
import MainContent from "@/components/MainContent.vue";
import PaginationComponent from "@/components/PaginationComponent.vue";
import NoData from "@/components/NoData.vue";
import LoadingLottie from "@/components/LoadingLottie.vue";
import { usePostOrderStatusStore } from "@/store";
import { storeToRefs } from "pinia";
import { onMounted, ref, onUnmounted } from "vue";

export default {
  components: {
    HeaderTitle,
    IconTransfer,
    MainContent,
    IconCheck,
    LoadingSpin,
    PaginationComponent,
    NoData,
    LoadingLottie,
  },
  setup() {
    const postOrderStatusStore = usePostOrderStatusStore();
    const { postOrderStatus } = storeToRefs(postOrderStatusStore);

    const length = ref(0);
    const limit = ref(20);
    const page = ref(1);
    const offset = ref(0);
    const isLoading = ref(false);
    let interval = null;

    const getPostOrderStatus = async (fromPolling = false) => {
      // hanya loading pada fetch manual / page change / initial
      if (!fromPolling) {
        isLoading.value = true;
      }

      offset.value = page.value - 1;

      const newData = await postOrderStatusStore.getPostOrderStatus({
        page: page.value,
        limit: limit.value,
        offset: offset.value,
      });

      length.value = newData.count;

      const stillRunning = newData.rows.some(
        (item) => item.status === "running"
      );

      if (!stillRunning) {
        clearInterval(interval);
        interval = null;
      }

      if (!fromPolling) {
        isLoading.value = false;
      }
    };

    const startPolling = () => {
      interval = setInterval(() => {
        getPostOrderStatus(true);
      }, 50000);
    };

    onMounted(() => {
      getPostOrderStatus();
      startPolling();
    });

    onUnmounted(() => {
      if (interval) clearInterval(interval);
    });

    const changePage = async (newPage) => {
      page.value = newPage;
      await getPostOrderStatus();

      // Selalu restart polling ketika pindah halaman
      if (interval) clearInterval(interval);

      const hasRunning = postOrderStatus.value.rows.some(
        (item) => item.status === "running"
      );

      if (hasRunning) {
        startPolling();
      }
    };

    return {
      postOrderStatus,
      length,
      limit,
      page,
      isLoading,
      changePage,
    };
  },
};
</script>

<style></style>
